import { render, staticRenderFns } from "./NewsMainView.vue?vue&type=template&id=0757ee80&"
import script from "./NewsMainView.vue?vue&type=script&lang=js&"
export * from "./NewsMainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports